export default {
    header: 'Refer to a provider in your Network',
    view_history: 'View history',
    back_to_network: 'Back to network',
    table: {
        provider: 'Provider',
        specialty: 'Specialty',
        location: 'location',
        insurance: 'Insurance',
        availability: 'AVAILABILITY',
        view_more: 'VIEW MORE',
        search_zip_code: 'Search zip code',
        per_page: 'per page',
    },
}
